import { render, staticRenderFns } from "./TermsAgreement.vue?vue&type=template&id=12759636&"
import script from "./TermsAgreement.vue?vue&type=script&lang=ts&"
export * from "./TermsAgreement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports